export default __webpack_public_path__ + "static/media/i1.7903e76e.jpg";